import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { DocumentsApiService } from 'features/document-report/api/documents-api.service';
import { queryClient } from 'providers';

import { DocumentQueryKeys } from './query-keys';
const { DocumentsLink } = DocumentsApiService();

export const useCreateUploadLink = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: FormData) => {
      return DocumentsLink(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: DocumentQueryKeys.all,
        });
      },
    },
  );
};
